import {
  useFilteredProcesses,
  useVisibleProcesses,
} from "utils/customHooks/genericHooks";
import styled from "styled-components/macro";
import useWindowSize from "utils/customHooks/useWindowSize";

export function ViewingNumProcessesIndicator() {
  const visibleProcesses = useVisibleProcesses();
  const filteredProcesses = useFilteredProcesses();
  const numViewing: string =
    filteredProcesses.length === visibleProcesses.length
      ? `All`
      : filteredProcesses.length.toString();
  const { innerWidth } = useWindowSize();
  return (
    <ViewingNumProcessesStyles>
      {innerWidth < 840 ? "" : "Viewing"} {numViewing}{" "}
      {numViewing === "1" ? "Process" : "Processes"}
      {numViewing === "All" ? ` (${filteredProcesses.length})` : ""}
    </ViewingNumProcessesStyles>
  );
}
const ViewingNumProcessesStyles = styled.div`
  text-decoration: underline;
  font-size: 18px;
  padding: 0 1em;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;
